<template>
    <section>
        <!-- <iframe src="http://223.99.217.146:10032/disp/" scrolling="no" style="width: 1100px;height: 520px;" frameborder="0"></iframe> -->

    </section>
</template>
<script>

	export default {
        data() {
			return {
			
			}
		},
        mounted() {
            window.open("https://seg-models.group/bigscreen/#/");
        }
    }
</script>


// WEBPACK FOOTER //
// NoiseMap.vue?71bfafc6